// @ts-nocheck
/* eslint-disable */
import {
  CONVERSION_VALUE_EVENTS_KEY,
  INSTALLS_EVENT_KEY,
  REINSTALLS_EVENT_KEY,
} from '../../../main/screens/ScreenSKAdNetwork/ScreenSKAdNetworkConstants';
import { ECPA, ECPC, ECPI, ECPM } from './datasources';

export const HOURS_FROM = {
  eo_install_hours_from_last_attributed_touch_to_event: 'click to install hours',
  eo_reinstall_hours_from_last_attributed_touch_to_event: 'click to reinstall hours',
};

export const FORMULAS = {
  eo_click_to_eo_install: 'click to install %',
  eo_click_to_eo_reinstall: 'click to reinstall %',
  eo_click_to_eo_open: 'click to open %',
  eo_click_to_eo_web_session_start: 'click to web session starts %',
  eo_branch_cta_view_to_eo_click: 'view to click %',
  eo_branch_cta_view_to_eo_install: 'view to install %',
  eo_branch_cta_view_to_eo_open: 'view to open %',
  eo_branch_cta_view_to_eo_dismissal: 'view to dismissal %',
  eo_branch_cta_view_to_PURCHASE: 'view to PURCHASE %',
  eo_branch_cta_view_to_ADD_TO_CART: 'view to ADD_TO_CART %',
  eo_branch_cta_view_to_ADD_TO_WISHLIST: 'view to ADD_TO_WISHLIST %',
  eo_branch_cta_view_to_VIEW_CART: 'view to VIEW_CART %',
  eo_branch_cta_view_to_INITIATE_PURCHASE: 'view to INITIATE_PURCHASE %',
  eo_branch_cta_view_to_ADD_PAYMENT_INFO: 'view to ADD_PAYMENT_INFO %',
  eo_branch_cta_view_to_SPEND_CREDITS: 'view to SPEND_CREDITS %',
  eo_branch_cta_view_to_RESERVE: 'view to RESERVE %',
  eo_branch_cta_view_to_CLICK_AD: 'view to CLICK_AD %',
  eo_branch_cta_view_to_VIEW_AD: 'view to VIEW_AD %',
  cost_to_revenue: 'ROI',
};

export const CURRENCY_FORMULAS = {
  eo_install_to_cost: ECPI,
  eo_click_to_cost: ECPC,
  eo_impression_to_cost: ECPM,
  PURCHASE_to_cost: ECPA,
};

export const FRAUD_FROM_TOUCH_TO_EVENT = {
  eo_install_seconds_from_last_attributed_touch_to_event_under_10: 'install % under 10s',
  eo_install_seconds_from_last_attributed_touch_to_event_between_10_and_30: 'install % 10-30s',
  eo_install_seconds_from_last_attributed_touch_to_event_over_30: 'install % 30s+',
  eo_install_days_from_last_attributed_touch_to_event_under_1: 'install % under 1d',
  eo_install_days_from_last_attributed_touch_to_event_over_1: 'install % 1d+',
};

export const FRAUD_FORMULAS = {
  fraud_codes_description: 'fraud description',
  eo_install_blocked_to_eo_install_total: '%',
  eo_click_blocked_to_eo_click_total: '%',
  eo_open_blocked_to_eo_open_total: '%',
  eo_reinstall_blocked_to_eo_reinstall_total: '%',
  eo_impression_blocked_to_eo_impression_total: '%',
};

export const FRAUD_TOTALS = {
  eo_install_plus_blocked: 'total installs',
  eo_click_plus_blocked: 'total clicks',
  eo_open_plus_blocked: 'total opens',
  eo_reinstall_plus_blocked: 'total reinstalls',
  eo_impression_plus_blocked: 'total impressions',
};

export const FRAUD_GROUPS = {
  fraud_codes_group: 'fraud code',
  short_cti_times: 'short install times',
  long_cti_times: 'long install times',
  blocked_install_group: 'blocked installs',
  blocked_click_group: 'blocked clicks',
  blocked_open_group: 'blocked opens',
  blocked_reinstall_group: 'blocked reinstalls',
  blocked_impression_group: 'blocked impressions',
};

/**
 * meta data for the cohorts calculated metrics.
 * Note: the menu property below is not added to the Cenarius query but rather used by the CohortMenuBar component to enable/disable certain buttons. There are some calculated metrics that rely on these buttons being selected. Calculations that have cumulative, per_user, or cost_per_event explicitly set to false will not be overriden when the query has values passed in for these tranformations.
 */
export const COHORT_CALCULATED_METRICS = {
  revenue: {
    measure: 'revenue',
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
    ],
  },
  ARPPU: {
    measure: 'ARPPU',
    cumulative: false,
    per_user: false,
    cost_per_event: false,
    fn: '/',
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
      {
        name: 'PURCHASE',
        metric: 'unique_count',
      },
    ],
  },
  GROSS_PROFIT: {
    measure: 'GROSS_PROFIT',
    cumulative: true,
    cost_per_event: false,
    cost_post_process: ['-'],
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
    ],
  },
  ROI: {
    measure: 'ROI',
    cumulative: true,
    cost_per_event: false,
    metric: 'percentage',
    cost_post_process: ['-', '/'],
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
    ],
  },
  ROAS: {
    measure: 'ROAS',
    cumulative: true,
    cost_per_event: false,
    fn: '/',
    metric: 'percentage',
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
      {
        data_source: 'cost',
        metric: 'cost',
      },
    ],
  },
  eCPA: {
    measure: 'eCPA',
    cost_per_event: true,
    cumulative: true,
    fields: [
      {
        name: 'PURCHASE',
      },
    ],
  },
  Retention: {
    measure: 'Retention',
    per_user: true,
    cumulative: false,
    cost_per_event: false,
    fields: [
      {
        name: 'OPEN',
        metric: 'unique_count',
      },
    ],
  },
  LTV: {
    measure: 'LTV',
    per_user: true,
    cumulative: true,
    cost_per_event: false,
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
    ],
  },
  ARPU: {
    measure: 'ARPU',
    cumulative: false,
    per_user: true,
    cost_per_event: false,
    fields: [
      {
        name: 'PURCHASE',
        metric: 'revenue',
      },
    ],
  },
};

export const CALCULTED_DATASOURCES_TO_BASIC_DATASOURCES = {
  eCPI: ['eo_install'],
  eCPC: ['eo_click'],
  eCPM: ['eo_impression'],
  eCPA: ['eo_commerce_event'],
  GROSS_PROFIT: ['eo_commerce_event'],
  ROI: ['eo_commerce_event'],
  ROAS: ['eo_commerce_event'],
};

export const EVENT_DESCRIPTIONS = {
  [INSTALLS_EVENT_KEY]: 'installs',
  [REINSTALLS_EVENT_KEY]: 'reinstalls',
  [CONVERSION_VALUE_EVENTS_KEY]: 'conversion events',
};
